<template>
  <div class="base-show-more">
    <div class="base-show-more__inner">
      <slot :open />
    </div>
    <TappButton
      v-if="active"
      class="base-show-more__button"
      tag="button"
      variant="ghost"
      data-analytics-category="content_interaction"
      data-analytics-action="item_click"
      :data-analytics-label="`show_more - ${open ? 'Toon minder' : 'Toon alles'}`"
      @click="open = !open"
    >
      {{ open ? 'Toon minder' : 'Toon alles' }}
      <TappIcon icon="arrow-down" class="base-show-more__icon" :class="[open && 'is-open']" />
    </TappButton>
  </div>
</template>

<script setup lang="ts">
  withDefaults(
    defineProps<{
      active: boolean;
    }>(),
    {
      active: false,
    },
  );

  const open = ref(false);
</script>

<style lang="postcss" scoped>
  .base-show-more {
    display: grid;
    gap: var(--spacing-8);

    @media (--screen-lg-up) {
      gap: var(--spacing-10);
    }
  }

  .base-show-more__button {
    place-self: start;
  }

  .base-show-more__icon {
    transition: transform 200ms ease-in-out;
  }

  .base-show-more__icon.is-open {
    transform: scaleY(-1);
  }

  @media (prefers-reduced-motion: reduce) {
    .base-show-more__icon {
      transition: none;
    }
  }
</style>
